export const NotificationManager = (setLocal, getURLBasePath) => {

    function fetchNotifications() {
        fetch(getURLBasePath() + 'notifications', {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setLocal(prevValue => {
                    return { ...prevValue, notifications: data };
                });
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    return {
        fetchNotifications
    };
}